import React from 'react';
import { FormControlLabel, Switch, Box } from '@mui/material';

export default function OutputOptionsArchiveField({
  value,
  setValue,
  setChanged,
  edit,
}) {
  const handleChange = (event) => {
    setValue(event.target.checked);
    setChanged();
  };

  return (
    <Box>
      <FormControlLabel
        control={
          <Switch
            checked={value || false}
            onChange={handleChange}
            name='output_options_archive'
          />
        }
        label='Compress Output'
      />
    </Box>
  );
}
